import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  position: relative;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`

export const BackLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.turquoiseDark};
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;

  svg {
    width: 1.2rem;
    height: 1.2rem;
  }
`

export const NameInput = styled.input`
  flex: 1;
  min-width: 15rem;
  padding: 0.8rem 1rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  font-size: 1.4rem;
  ${(p) => p.theme.bold};
  color: ${(p) => p.theme.colors.black};
  background: ${(p) => p.theme.colors.white};

  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.colors.turquoiseDark};
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-left: auto;
`

export const CanvasSection = styled.div`
display: flex;
`
